import { ShareUserViewModel, UserSelectValue } from '@dntlab/share-files-dialog';

export function shareUserViewModelToUserSelectValueAdapter(users: ShareUserViewModel[]): UserSelectValue[] {
  return users.map((user: ShareUserViewModel) => ({
    itemName: user.displayName,
    id: user.id,
    image: user.imageUrl,
  }));
}
